// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"3333ea03","666":"bee1f7d3","787":"db7630f8","903":"072f3da7"}[chunkId] + ".chunk.js";
};